import React from 'react'

const MatchedStudent = ({ matchedStudent }) => {
  if (!matchedStudent) return
  return (
    <div className="mb-4 p-3 border rounded bg-light">
      <h5 className="text-primary mb-3">
        <strong>📋 Student Master Record (Reference Only)</strong>
      </h5>
      <div className="row">
        <div className="col-md-6">
          <p className="mb-2">
            <strong>PERM Number:</strong>{' '}
            <span className="text-monospace">
                  {matchedStudent.permNumber}
                </span>
          </p>
          <p className="mb-2">
            <strong>Name:</strong> {matchedStudent.firstName}{' '}
            {matchedStudent.middleName || ''} {matchedStudent.lastName}{' '}
            {matchedStudent.postName || ''}
          </p>
          <p className="mb-2">
            <strong>Former Last Name:</strong>{' '}
            {matchedStudent.formerLastName || 'N/A'}
          </p>
        </div>
        <div className="col-md-6">
          <p className="mb-2">
            <strong>Date of Birth:</strong>{' '}
            {(new Date(matchedStudent.dateOfBirth)).toLocaleDateString()}
          </p>
          <p className="mb-2">
            <strong>Gender:</strong> {matchedStudent.gender}
          </p>
        </div>
      </div>
      <small className="text-muted">
        <em>
          This data is from the official student master database and is for
          reference only. You can copy information from here if needed.
        </em>
      </small>
    </div>
  )

}
export default MatchedStudent